import omit from 'lodash/omit';
import { createSelector } from '@reduxjs/toolkit';
import { MultiUserClientStatesById, MultiUserRootState } from './types';

export const selectLatestMultiUserPollId = (state: MultiUserRootState) => state.multiuser.latestLongPollId;
export const selectMultiUserClientId = (state: MultiUserRootState) => state.multiuser.options?.clientId;
export const selectMultiUserClients = (state: MultiUserRootState) => state.multiuser.clients;
export const selectOtherMultiUserClients = createSelector(
  selectMultiUserClientId,
  selectMultiUserClients,
  (ownClientId, clients): MultiUserClientStatesById => (ownClientId ? omit(clients, ownClientId) : clients),
);
